module.exports = __webpack_public_path__ + "assets/img/news (4).d1775d13.png";